export default {
  alvara: state => state.tributario.obrasParticulares.alvara
};
